export const flipCard = (() => {
    const flipCards = document.querySelectorAll('.flip-card');

    const init = () => {
        if(!flipCards) return

        flipCard();
    }   

    const flipCard = () => {
         // Get all the flip cards on the page

        // Initialize the maximum back body height
        let maxBackBodyHeight = 0;

        // First loop to find the maximum back body height
        flipCards.forEach((card) => {
            // Get the body of the back side
            const backBody = card.querySelector('.flip-card-back .card-product-body');

            // Update the maximum back body height
            if (backBody.offsetHeight > maxBackBodyHeight) {
                maxBackBodyHeight = backBody.offsetHeight;
            }
        });

        // Second loop to set the heights
        flipCards.forEach((card) => {
            // Get the header and body of the card
            const frontHeader = card.querySelector('.flip-card-front .card-product-header');
            const frontBody = card.querySelector('.flip-card-front .card-product-body');
            const backBody = card.querySelector('.flip-card-back .card-product-body');

            // Set the height of the front body and back body to the maximum back body height
            frontBody.style.height = `${maxBackBodyHeight}px`;
            backBody.style.height = `${maxBackBodyHeight}px`;

            // Calculate the total height of the front header and body
            const frontTotalHeight = frontHeader.offsetHeight + frontBody.offsetHeight;

            // Set the CSS variable on the flip card
            card.style.setProperty('--flip-card-height', `${frontTotalHeight}px`);

            // Add a hover event listener to the card
            card.addEventListener('mouseover', () => {
                // Get the header of the back side
                const backHeader = card.querySelector('.flip-card-back .card-product-header');

                // Calculate the total height of the back header and body
                const backTotalHeight = backHeader.offsetHeight + backBody.offsetHeight;

                // Set the CSS variable on the flip card
                card.style.setProperty('--flip-card-height', `${backTotalHeight}px`);
            });

            // Add a mouseout event listener to the card to reset the height when the mouse leaves the card
            card.addEventListener('mouseout', () => {
                card.style.setProperty('--flip-card-height', `${frontTotalHeight}px`);
            });
        });
    }

    return {
        init
    }
})();